/* Faris Collection — storefront behaviour (no dependencies). */
(() => {
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => [...el.querySelectorAll(s)];
  const T = window.theme || { routes: {}, strings: {} };
  const root = (T.routes.root || '/').replace(/\/?$/, '/');

  /* ---------------- money ---------------- */
  function formatMoney(cents) {
    const fmt = T.moneyFormat || 'Rs.{{amount_no_decimals}}';
    const n = Number(cents) / 100;
    const group = (num, dec, sep = ',', decSep = '.') => {
      const [i, d] = num.toFixed(dec).split('.');
      return i.replace(/\B(?=(\d{3})+(?!\d))/g, sep) + (d ? decSep + d : '');
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => ({
      amount: group(n, 2),
      amount_no_decimals: group(n, 0),
      amount_with_comma_separator: group(n, 2, '.', ','),
      amount_no_decimals_with_comma_separator: group(n, 0, '.'),
      amount_with_apostrophe_separator: group(n, 2, "'"),
    }[k] ?? group(n, 0)));
  }
  window.formatMoney = formatMoney;

  /* ---------------- toast ---------------- */
  let toastTimer;
  function toast(msg) {
    const el = $('[data-toast]');
    if (!el) return;
    el.textContent = msg;
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => el.classList.remove('is-visible'), 2600);
  }

  /* ---------------- drawers ---------------- */
  const overlay = $('[data-overlay]');
  let openDrawerEl = null;
  let lastFocus = null;
  function openDrawer(id) {
    const d = document.getElementById(id);
    if (!d) return;
    if (openDrawerEl && openDrawerEl !== d) closeDrawer(true);
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    overlay.hidden = false;
    requestAnimationFrame(() => overlay.classList.add('is-visible'));
    document.body.classList.add('is-locked');
    openDrawerEl = d;
    const f = $('[autofocus], input, button, a', d);
    setTimeout(() => f && f.focus({ preventScroll: true }), 80);
  }
  function closeDrawer(keepOverlay) {
    if (!openDrawerEl) return;
    openDrawerEl.classList.remove('is-open');
    openDrawerEl.setAttribute('aria-hidden', 'true');
    openDrawerEl = null;
    if (!keepOverlay) {
      overlay.classList.remove('is-visible');
      setTimeout(() => { if (!openDrawerEl) overlay.hidden = true; }, 300);
      document.body.classList.remove('is-locked');
      lastFocus && lastFocus.focus && lastFocus.focus({ preventScroll: true });
    }
  }
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-open-drawer]');
    if (opener) { e.preventDefault(); openDrawer(opener.dataset.openDrawer); return; }
    if (e.target.closest('[data-close-drawer]') || e.target === overlay) closeDrawer();
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeDrawer(); });

  /* ---------------- header ---------------- */
  const headerWrap = $('[data-header]');
  if (headerWrap) {
    // the whole wrapper (promise strip + header + mobile chips) is sticky; expose its height for other sticky bars
    const setH = () => document.documentElement.style.setProperty('--header-h', headerWrap.offsetHeight + 'px');
    let scrolled = null;
    const onScroll = () => {
      const now = window.scrollY > 40;
      if (now === scrolled) return;
      scrolled = now;
      headerWrap.classList.toggle('is-scrolled', now);
      requestAnimationFrame(setH);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll(); setH(); window.addEventListener('resize', setH);
  }
  $$('[data-announcement]').forEach((bar) => {
    const items = $$('.announcement__item', bar);
    if (items.length < 2) return;
    let i = 0;
    setInterval(() => {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, Number(bar.dataset.speed || 4500));
  });

  /* ---------------- cart ---------------- */
  async function refreshCart(open = true) {
    try {
      const res = await fetch(`${root}?sections=cart-drawer`);
      const data = await res.json();
      const html = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
      const fresh = $('#CartDrawer', html);
      const current = $('#CartDrawer');
      if (fresh && current) {
        ['.drawer__head', '.drawer__body', '.drawer__foot'].forEach((sel) => {
          const a = $(sel, current); const b = $(sel, fresh);
          if (a && b) a.replaceWith(b); else if (a && !b) a.remove(); else if (!a && b) current.appendChild(b);
        });
        const count = fresh.dataset.count;
        $$('[data-cart-count]').forEach((el) => { el.textContent = count === '0' ? '' : count; el.dataset.count = count; });
      }
      if (open) openDrawer('CartDrawer');
    } catch (e) { if (open) window.location.href = T.routes.cart; }
  }

  async function addItems(items) {
    const res = await fetch(`${T.routes.cartAdd}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items }),
    });
    const json = await res.json();
    if (!res.ok) throw new Error(json.description || json.message || T.strings.error);
    return json;
  }
  window.themeAddItems = addItems;

  async function changeLine(line, quantity) {
    await fetch(`${T.routes.cartChange}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line, quantity }),
    });
    if ($('[data-cart-page]')) window.location.reload(); else refreshCart(false);
  }

  document.addEventListener('click', (e) => {
    const q = e.target.closest('[data-line-qty]');
    if (q) { e.preventDefault(); changeLine(Number(q.dataset.line), Math.max(0, Number(q.dataset.lineQty))); return; }
    const rm = e.target.closest('[data-line-remove]');
    if (rm) { e.preventDefault(); changeLine(Number(rm.dataset.lineRemove), 0); }
  });

  // Quick add (product cards + upsells)
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    btn.classList.add('is-loading');
    try {
      await addItems([{ id: Number(btn.dataset.quickAdd), quantity: 1 }]);
      document.dispatchEvent(new CustomEvent('cart:added', { detail: { source: btn } }));
      await refreshCart(true);
    } catch (err) { toast(err.message); }
    btn.classList.remove('is-loading');
    const card = btn.closest('.card'); card && card.classList.remove('is-quick-open');
  });
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-quick-toggle]');
    if (!t) return;
    e.preventDefault();
    const card = t.closest('.card');
    $$('.card.is-quick-open').forEach((c) => c !== card && c.classList.remove('is-quick-open'));
    card.classList.toggle('is-quick-open');
  });

  /* ---------------- product form ---------------- */
  class ProductForm {
    constructor(el) {
      this.el = el;
      this.data = JSON.parse(($('[data-product-json]', el) || $('[data-product-json]')).textContent);
      this.form = $('form[data-product-form]', el);
      this.idInput = $('input[name="id"]', this.form);
      this.sticky = $('[data-sticky-atc]');
      this.sizeChosen = !!el.dataset.sizePreselected;
      el.addEventListener('change', (e) => {
        if (e.target.matches('[data-option-input]')) {
          if (e.target.dataset.optionName === 'size') this.sizeChosen = true;
          this.update();
        }
      });
      this.form.addEventListener('submit', (e) => this.submit(e));
      $$('[data-buy-now]', el).forEach((b) => b.addEventListener('click', (e) => this.buyNow(e)));
      $$('[data-qty]', el).forEach((w) => this.bindQty(w));
      this.bindSticky();
      this.update(true);
    }
    bindQty(w) {
      const input = $('input', w);
      $$('button', w).forEach((b) => b.addEventListener('click', () => {
        input.value = Math.max(1, Number(input.value) + Number(b.dataset.step));
      }));
    }
    selected() {
      return this.data.options.map((name, i) => {
        const checked = $(`[data-option-index="${i}"]:checked`, this.el) || $(`select[data-option-index="${i}"]`, this.el);
        return checked ? checked.value : null;
      });
    }
    findVariant(opts) {
      // with no age chosen yet, fall back to the first in-stock variant of the chosen colour
      const matches = this.data.variants.filter((v) => v.options.every((o, i) => opts[i] == null || o === opts[i]));
      return matches.find((v) => v.available) || matches[0];
    }
    update(initial) {
      const opts = this.selected();
      const variant = this.findVariant(opts);
      this.variant = variant;
      // availability per size for current colour
      const sizeIdx = this.data.options.findIndex((o) => /size|age/i.test(o));
      if (sizeIdx > -1) {
        $$(`[data-option-index="${sizeIdx}"]`, this.el).forEach((inp) => {
          const test = opts.slice(); test[sizeIdx] = inp.value;
          const v = this.data.variants.find((x) => x.options.every((o, i) => o === test[i]));
          inp.closest('.size-btn') && inp.closest('.size-btn').classList.toggle('is-unavailable', !v || !v.available);
          $$(`[data-sheet-size="${CSS.escape(inp.value)}"]`).forEach((b) => { b.disabled = !v || !v.available; b.classList.toggle('is-unavailable', !v || !v.available); });
        });
      }
      $$('[data-selected-value]', this.el).forEach((s) => {
        const i = Number(s.dataset.selectedValue);
        s.textContent = (i === sizeIdx && !this.sizeChosen) ? '' : opts[i] || '';
      });
      if (!variant) return;
      this.idInput.value = variant.id;
      const priceHtml = this.priceHtml(variant);
      $$('[data-price]', document).forEach((p) => (p.innerHTML = priceHtml));
      const btn = $('[data-add-button]', this.el);
      const stock = $('[data-stock]', this.el);
      const needSize = sizeIdx > -1 && !this.sizeChosen;
      if (btn) {
        btn.disabled = !variant.available;
        btn.textContent = !variant.available ? T.strings.soldOut : T.strings.addToCart;
      }
      if (stock) {
        const qty = variant.inventory;
        stock.hidden = needSize;
        stock.className = 'stock-note' + (!variant.available ? ' is-out' : qty != null && qty <= 3 ? ' is-low' : '');
        stock.textContent = !variant.available ? stock.dataset.out : qty != null && qty <= 3 ? stock.dataset.low.replace('[count]', qty) : stock.dataset.in;
      }
      if (!initial) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
        if (variant.media_id) {
          const slide = $(`[data-media-id="${variant.media_id}"]`);
          if (slide) slide.parentElement.scrollTo({ left: slide.offsetLeft, behavior: 'auto' });
        }
        document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant, size: sizeIdx > -1 ? opts[sizeIdx] : null } }));
      }
      if (this.sticky) {
        const sb = $('[data-sticky-button]', this.sticky);
        if (sb) { sb.disabled = !variant.available; sb.textContent = !variant.available ? T.strings.soldOut : (needSize ? T.strings.selectSize : T.strings.addToCart); }
        const ss = $('[data-sticky-size]', this.sticky);
        if (ss && sizeIdx > -1 && this.sizeChosen) ss.value = opts[sizeIdx];
      }
    }
    priceHtml(v) {
      const sale = v.compare_at_price && v.compare_at_price > v.price;
      return `<div class="price${sale ? ' price--sale' : ''}"><span class="price__current">${formatMoney(v.price)}</span>${sale ? `<s class="price__compare">${formatMoney(v.compare_at_price)}</s><span class="price__save">Save ${Math.round((1 - v.price / v.compare_at_price) * 100)}%</span>` : ''}</div>`;
    }
    requireSize() {
      const sizeIdx = this.data.options.findIndex((o) => /size|age/i.test(o));
      if (sizeIdx > -1 && !this.sizeChosen) {
        const hint = $('[data-size-hint]', this.el);
        if (hint) hint.textContent = T.strings.selectSize;
        const grid = $('[data-size-grid]', this.el);
        grid && grid.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return false;
      }
      return true;
    }
    async submit(e) {
      e.preventDefault();
      if (!this.requireSize() || !this.variant) return;
      const btn = $('[data-add-button]', this.el);
      btn.classList.add('is-loading');
      const qty = Number(($('input[name="quantity"]', this.form) || {}).value || 1);
      try { await addItems([{ id: this.variant.id, quantity: qty }]); document.dispatchEvent(new CustomEvent('cart:added', { detail: { source: btn } })); await refreshCart(true); }
      catch (err) { toast(err.message); }
      btn.classList.remove('is-loading');
    }
    async buyNow(e) {
      e.preventDefault();
      if (!this.requireSize() || !this.variant) return;
      e.currentTarget.classList.add('is-loading');
      const qty = Number(($('input[name="quantity"]', this.form) || {}).value || 1);
      try { await addItems([{ id: this.variant.id, quantity: qty }]); window.location.href = '/checkout'; }
      catch (err) { toast(err.message); e.currentTarget.classList.remove('is-loading'); }
    }
    bindSticky() {
      if (!this.sticky) return;
      const target = $('[data-add-button]', this.el);
      new IntersectionObserver(([en]) => {
        // show whenever the main Add to cart button is off-screen (above or below)
        this.sticky.classList.toggle('is-visible', !en.isIntersecting);
      }).observe(target);
      const ss = $('[data-sticky-size]', this.sticky);
      const sizeIdx = this.data.options.findIndex((o) => /size|age/i.test(o));
      ss && ss.addEventListener('change', () => {
        const inp = $$(`[data-option-index="${sizeIdx}"]`, this.el).find((i) => i.value === ss.value);
        if (inp) { inp.checked = true; this.sizeChosen = true; this.update(); }
      });
      $('[data-sticky-button]', this.sticky).addEventListener('click', (e) => {
        if (!this.sizeChosen && sizeIdx > -1) {
          if (ss && window.matchMedia('(min-width: 750px)').matches) { ss.focus(); return; }
          openDrawer('SizePicker');
          return;
        }
        this.form.requestSubmit ? this.form.requestSubmit() : this.submit(e);
      });
      // mobile size picker sheet
      $$('[data-sheet-size]').forEach((b) => b.addEventListener('click', () => {
        const inp = $$(`[data-option-index="${sizeIdx}"]`, this.el).find((i) => i.value === b.dataset.sheetSize);
        if (inp) { inp.checked = true; this.sizeChosen = true; this.update(); }
        closeDrawer();
        this.form.requestSubmit ? this.form.requestSubmit() : null;
      }));
    }
  }
  $$('[data-product]').forEach((el) => { try { new ProductForm(el); } catch (e) { console.error(e); } });

  /* ---------------- gallery: featured image + thumbnails ---------------- */
  $$('[data-gallery]').forEach((g) => {
    const track = $('.gallery__track', g);
    const thumbs = $$('[data-thumb]', g);
    const current = $('[data-gallery-current]', g);
    if (!track) return;
    const count = $$('.gallery__slide', track).length;
    const index = () => Math.round(track.scrollLeft / track.clientWidth);
    const go = (i) => track.scrollTo({ left: ((i + count) % count) * track.clientWidth, behavior: 'auto' });
    const sync = () => {
      const i = index();
      thumbs.forEach((t, j) => { t.classList.toggle('is-active', i === j); t.setAttribute('aria-selected', i === j); });
      if (current) current.textContent = i + 1;
      const active = thumbs[i];
      if (active) active.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    };
    track.addEventListener('scroll', () => { clearTimeout(track._t); track._t = setTimeout(sync, 60); }, { passive: true });
    thumbs.forEach((t) => t.addEventListener('click', () => { go(Number(t.dataset.thumb)); sync(); }));
    $$('[data-gallery-step]', g).forEach((b) => b.addEventListener('click', () => { go(index() + Number(b.dataset.galleryStep)); sync(); }));
  });

  /* ---------------- complete the look ---------------- */
  $$('[data-look]').forEach((look) => {
    const items = $$('[data-look-item]', look);
    const total = $('[data-look-total]', look);
    const recalc = () => {
      let sum = 0; let count = 0;
      items.forEach((it) => {
        const on = $('[data-look-check]', it).checked;
        it.classList.toggle('is-off', !on);
        const sel = $('select', it);
        const opt = sel ? sel.selectedOptions[0] : null;
        if (on && opt) { sum += Number(opt.dataset.lookPrice); count++; }
      });
      if (total) total.textContent = formatMoney(sum);
      const btn = $('[data-look-add]', look);
      if (btn) btn.disabled = count === 0;
    };
    look.addEventListener('change', (e) => {
      // choosing a size on the main piece pre-selects the same size on the other pieces
      const mainItem = e.target.closest('[data-main]');
      if (mainItem && e.target.matches('select')) {
        const size = e.target.selectedOptions[0] && e.target.selectedOptions[0].dataset.size;
        items.forEach((it) => {
          const sel = $('select', it);
          if (it === mainItem || !sel || !size || sel.value) return;
          const opt = [...sel.options].find((o) => o.dataset.size === size && !o.disabled);
          if (opt) sel.value = opt.value;
        });
      }
      recalc();
    });
    // keep pieces in the same size as the main product
    document.addEventListener('variant:change', (e) => {
      if (!e.detail.size) return;
      items.forEach((it) => {
        const sel = $('select', it);
        if (!sel || it.dataset.lockSize === 'false') return;
        const opt = [...sel.options].find((o) => o.dataset.size === e.detail.size && !o.disabled);
        if (opt) sel.value = opt.value;
      });
      recalc();
    });
    const addBtn = $('[data-look-add]', look);
    addBtn && addBtn.addEventListener('click', async () => {
      const chosen = items.filter((it) => $('[data-look-check]', it).checked).map((it) => $('select', it));
      if (chosen.some((s) => !s.value)) { toast(T.strings.selectSize); chosen.find((s) => !s.value).focus(); return; }
      addBtn.classList.add('is-loading');
      try {
        await addItems(chosen.map((s) => ({ id: Number(s.value), quantity: 1 })));
        document.dispatchEvent(new CustomEvent('cart:added', { detail: { source: addBtn } }));
        await refreshCart(true);
        toast(T.strings.lookAdded);
      } catch (err) { toast(err.message); }
      addBtn.classList.remove('is-loading');
    });
    // Arriving from an outfit card (?look=<pair-handle>) pre-selects exactly that outfit.
    const lookParam = new URLSearchParams(window.location.search).get('look');
    if (lookParam && items.some((it) => it.dataset.handle === lookParam)) {
      items.forEach((it) => {
        if (!it.hasAttribute('data-main')) $('[data-look-check]', it).checked = it.dataset.handle === lookParam;
      });
    }
    recalc();
  });

  /* ---------------- rails ---------------- */
  $$('[data-rail-nav]').forEach((nav) => {
    const rail = document.getElementById(nav.dataset.railNav);
    if (!rail) return;
    $$('button', nav).forEach((b) => b.addEventListener('click', () => {
      rail.scrollBy({ left: Number(b.dataset.dir) * rail.clientWidth * 0.8, behavior: 'smooth' });
    }));
  });

  /* ---------------- reveal ---------------- */
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => entries.forEach((en) => {
      if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
    }), { rootMargin: '0px 0px -8% 0px' });
    $$('.reveal').forEach((el) => io.observe(el));
  } else $$('.reveal').forEach((el) => el.classList.add('is-in'));

  /* ---------------- predictive search ---------------- */
  const ps = $('[data-predictive]');
  if (ps) {
    const input = $('input[name="q"]', ps.closest('form') || document);
    const out = $('[data-predictive-results]');
    let t;
    input && input.addEventListener('input', () => {
      clearTimeout(t);
      const q = input.value.trim();
      if (q.length < 2) { out.innerHTML = ''; return; }
      t = setTimeout(async () => {
        try {
          const r = await fetch(`${T.routes.predictiveSearch}.json?q=${encodeURIComponent(q)}&resources[type]=product,collection&resources[limit]=6`);
          const j = await r.json();
          const res = j.resources.results;
          const cols = (res.collections || []).slice(0, 4).map((c) => `<a class="chip" href="${c.url}">${c.title}</a>`).join('');
          const prods = (res.products || []).map((p) => `
            <a class="predictive__item" href="${p.url}">
              <div class="media">${p.featured_image && p.featured_image.url ? `<img src="${p.featured_image.url}&width=160" alt="" loading="lazy">` : ''}</div>
              <div><div class="predictive__title">${p.title}</div><div class="small muted">${p.type || ''} · ${formatMoney(Math.round(parseFloat(p.price) * 100))}</div></div>
            </a>`).join('');
          out.innerHTML = (cols ? `<div class="search-popular" style="margin-top:0">${cols}</div>` : '') + (prods || `<p class="muted">No matches for “${q}”.</p>`);
        } catch (e) { /* ignore */ }
      }, 220);
    });
  }

  /* ---------------- collection filters ---------------- */
  $$('[data-filter-form]').forEach((form) => {
    form.addEventListener('change', (e) => {
      if (e.target.matches('input[type="number"]')) return;
      submitFilters(form);
    });
    form.addEventListener('submit', (e) => { e.preventDefault(); submitFilters(form); });
  });
  function submitFilters(form) {
    const params = new URLSearchParams(new FormData(form));
    for (const [k, v] of [...params.entries()]) if (v === '') params.delete(k);
    const sort = $('[data-sort]');
    if (sort && sort.value) params.set('sort_by', sort.value);
    window.location.search = params.toString();
  }
  $$('[data-sort]').forEach((s) => s.addEventListener('change', () => {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', s.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  }));
  $$('.facet__list--sizes input').forEach((i) => i.closest('.facet__opt').classList.toggle('is-checked', i.checked));

  /* ---------------- wedding hub tabs ---------------- */
  $$('[data-events]').forEach((hub) => {
    const tabs = $$('[data-event-tab]', hub);
    const panels = $$('[data-event-panel]', hub);
    const select = (key, scroll) => {
      tabs.forEach((t) => { const on = t.dataset.eventTab === key; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on); });
      panels.forEach((p) => p.classList.toggle('is-active', p.dataset.eventPanel === key));
      if (scroll) $('[data-event-step]', hub).scrollIntoView({ behavior: 'smooth', block: 'start' });
      const url = new URL(window.location.href); url.hash = key; history.replaceState({}, '', url);
    };
    tabs.forEach((t) => t.addEventListener('click', () => select(t.dataset.eventTab, true)));
    const fromHash = window.location.hash.replace('#', '');
    if (fromHash && tabs.some((t) => t.dataset.eventTab === fromHash)) select(fromHash, false);
  });

  /* ---------------- size guide tabs ---------------- */
  $$('[data-size-tabs]').forEach((wrap) => {
    $$('[data-size-tab]', wrap).forEach((b) => b.addEventListener('click', () => {
      $$('[data-size-tab]', wrap).forEach((x) => x.classList.toggle('is-active', x === b));
      $$('[data-size-table]', wrap).forEach((t) => (t.hidden = t.dataset.sizeTable !== b.dataset.sizeTab));
    }));
  });
})();
